import { Tag, Dot } from '@/components/Tag';
import { money, qty } from '@/lib/format';
import { availability } from './status';
import type { StockSummaryRow } from './types';
import s from './StockCards.module.css';

/** 「CZ01 · 常州主仓，SZ02 · 苏州分仓」→「常州主仓 · 苏州分仓」 */
export function warehouseNames(v?: string | null) {
  if (!v) return '';
  return v
    .split('，')
    .map((x) => x.split(' · ').slice(1).join(' · ') || x)
    .join(' · ');
}

/** 可用数：负数红字（文档 23 §11：可用可以为负，只提示不拦） */
export function Avail({ value, strong }: { value: unknown; strong?: boolean }) {
  const n = Number(value) || 0;
  return <span className={[n < 0 ? 'neg' : '', strong ? s.strong : ''].join(' ')}>{n < 0 ? `−${qty(-n)}` : qty(n)}</span>;
}

/** 库存卡（L1）：产品 + 现有 / 预占 / 可用三格 + 仓库分布与货值 */
export function StockCard({ row, onOpen, selected }: { row: StockSummaryRow; onOpen: () => void; selected?: boolean }) {
  const av = availability(row.currentQuantity, row.availableQuantity);
  return (
    <button type="button" className={[s.card, selected && s.sel].filter(Boolean).join(' ')} onClick={onOpen}>
      <div className={s.h}>
        <b>{row.productName}</b>
        {av.solid ? <Tag tone={av.tone} sm>{av.label}</Tag> : av.tone === 'amber' ? <Dot tone="amber">{av.label}</Dot> : null}
      </div>
      <div className={s.sub}>
        <span className="tnum">{row.productCode}</span>
        {row.category && <span>{row.category}</span>}
      </div>
      <div className={s.m}>
        <div><span>现有</span><b className="tnum">{qty(row.currentQuantity)}</b></div>
        <div><span>预占</span><b className="tnum">{qty(row.reservedQuantity)}</b></div>
        <div><span>可用</span><b className="tnum"><Avail value={row.availableQuantity} /></b></div>
      </div>
      <div className={s.f}>
        <span className={s.wh}><i>仓库</i>{row.warehouseDistribution?.length ? row.warehouseDistribution.map((warehouse) => `${warehouse.name} ${qty(warehouse.quantity)}`).join(' · ') : warehouseNames(row.warehouses) || <span className="em">未入过库</span>}</span>
        {row.inventoryValue !== undefined && <span className={s.val}><i>价值</i><b className="tnum">{money(row.inventoryValue)}</b></span>}
      </div>
    </button>
  );
}
